module.exports = __webpack_public_path__ + "84d40bb09bb6ae07beb6a3bbdee683b4.pdf";